import useRequest, {
    RequestFn,
    RequestKeys,
} from 'app/hooks/useRequest'

import longTermLeaseFeesRequests from '../LongTermLeaseFees.requests'

const useGetLongTermLeaseFees = ({
    longTermLeaseFeesId,
}: {
    longTermLeaseFeesId: number,
}) => {
    return useRequest({
        key: RequestKeys.getLongTermLeaseFees,
        params: {
            longTermLeaseFeesId,
        },
        requestFunc: RequestFn.getEntity(longTermLeaseFeesRequests.getLongTermLeaseFees),
        enabled: Boolean(longTermLeaseFeesId),
    })
}

export default useGetLongTermLeaseFees
